'use client';

import BodyLink from '@jouzen/ecom-components/v3/BodyLink';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { OrderInfo, type OrderInfoProps } from '@/app/components/ui';
import { useOrderData } from '@/app/hooks';
import { box } from '@/app/styles/ui';
import { usePathname, useRouter } from '@/i18n/routing';
import { OrderStatus, PaymentMethod } from '@/types/Order';

import { STEP } from '../const';

interface EssenceOrderInfoProps {
  readonly address: OrderInfoProps['address'];
  readonly email: OrderInfoProps['email'];
  readonly className?: OrderInfoProps['className'];
}

const EssenceOrderInfo = ({
  address,
  email,
  className,
}: EssenceOrderInfoProps) => {
  const t = useTranslations();
  const { push } = useRouter();
  const currentStep = usePathname();
  const { shippingAddress, orderStatus, paymentMethod } = useOrderData();

  const showEditAddress =
    Boolean(shippingAddress?.address) &&
    orderStatus === OrderStatus.pending &&
    paymentMethod === PaymentMethod.net_terms &&
    currentStep === STEP.REVIEW.path;

  return (
    <div>
      {showEditAddress && (
        <p className="pb-2 text-right text-blue-100">
          <BodyLink
            color="inherit"
            onClick={(e) => {
              e.preventDefault();
              push(`${STEP.DELIVERY.path}?returnTo=review`);
            }}
          >
            {t('eop_order_selections_page_edit_address')}
          </BodyLink>
        </p>
      )}

      <OrderInfo
        className={cx(box(), className)}
        address={address}
        email={email}
      />
    </div>
  );
};

export default EssenceOrderInfo;
